export const joinHostAndPath = (hostname, pathname) => {
    const cleanedHostname = hostname.replace(/\/+$/, '');
    const cleanedPathname = pathname.replace(/^\/+/, '');
    return new URL(cleanedPathname, cleanedHostname).toString();
};
//# sourceMappingURL=network.js.map